import Icon from "../Icon";
import { MaterialNames } from "../material_symbol_names";
import type { KeyboardEvent } from "react";

import classNames from "classnames";

export interface ActionCardProps {
  iconName: MaterialNames;
  title: string;
  text: string;
  className?: string;
  actionFn?: () => void;
  trailingIcon?: MaterialNames;
}

export default function ActionCard({
  iconName,
  title,
  text,
  className,
  actionFn,
  trailingIcon = "navigate_next"
}: ActionCardProps) {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!actionFn || (event.key !== "Enter" && event.key !== " ")) return;

    event.preventDefault();
    actionFn();
  };

  return (
    <div
      className={classNames(
        "flex items-center p-5 max-w-[600px] cursor-pointer transition-all duration-200 ease-in-out h-full",
        "border-2 border-extended-pgadarknavy-brand-color rounded-lg hover:bg-extended-pgasilver-brand-color hover:bg-opacity-40",
        className
      )}
      data-testid="nav-card"
      onClick={actionFn}
      onKeyDown={handleKeyDown}
      role={actionFn ? "button" : undefined}
      tabIndex={actionFn ? 0 : undefined}
    >
      <div className="flex items-start h-full flex-1 min-w-0">
        <div className="bg-sys-brand-secondary-container rounded-full p-2 mr-4 flex items-center justify-center shrink-0">
          <Icon name={iconName} size={24} />
        </div>
        <div className="flex-column items-center justify-center min-w-0">
          <p className="text-title-medium-bold mb-1">{title}</p>
          <p className="text-body-medium">{text}</p>
        </div>
      </div>
      <Icon className="flex justify-center ml-4 shrink-0" name={trailingIcon} />
    </div>
  );
}
